import { AdminUserRealm } from 'further-types/admin-user';
import api from 'lib/trpcClient';
import { SortOrder } from 'further-types/utils';

export default function useAvailableVehicles(realm?: AdminUserRealm) {
  const { data: vehicles, isLoading } = api.vehicle.listAllVehicles.useQuery(
    {
      order: SortOrder.Desc,
      orderBy: 'vehicleName',
    },
    {
      enabled: realm === AdminUserRealm.Lp,
    },
  );

  return {
    availableVehicles: vehicles?.result ?? [],
    isLoading,
  };
}
